module.exports = __webpack_public_path__ + "img/preview.28f61d16.jpg";